import { useMemo, useState, useEffect } from 'react';
import { motion, Variants } from 'framer-motion';
import { RhLink } from '@components';
import { type ListCoverStory } from './ListCoverStories';

// Utils
import { formatDate } from '@/core/utils';
import { hasCompletedGame, getCompletedGame } from '@/components/CoverStory/Game/config/gameLocalStorage';

// Styles
import styles from './ListCoverStories.module.scss';
import className from 'classnames/bind';
const cx = className.bind(styles);

type ItemProps = ListCoverStory & {
  variants?: Variants;
  solvedLabelSingular?: string;
  solvedLabelPlural?: string;
  lostLabel?: string;
}

export default function ListCoverStoriesItem({ title, uri, gameData, variants, solvedLabelSingular, solvedLabelPlural, lostLabel }: ItemProps) {
  const { coverStoryDate, gameNumber } = gameData || {};
  const date = useMemo(() => formatDate(coverStoryDate), [coverStoryDate]);
  const [hasPlayed, setHasPlayed] = useState(false);
  const [didWin, setDidWin] = useState<boolean | null>(null);
  const [guessCount, setGuessCount] = useState<number>(0);

  // -------------------- CMS data setup

  const Copy_ItemLabels = {
    solvedSingular: solvedLabelSingular || 'Missing Solved in 1 Tile',
    solvedPlural: solvedLabelPlural || 'Missing Solved in {{COUNT}} Tiles',
    lostLabel: lostLabel || 'Missing you lost',
  };

  // Check if user has already played this game and if they won
  useEffect(() => {
    if (gameNumber && typeof window !== 'undefined') {
      const completedGame = getCompletedGame(String(gameNumber));
      if (completedGame) {
        setHasPlayed(true);
        setDidWin(completedGame.won);
        setGuessCount(completedGame.guessCount);
      }
    }
  }, [gameNumber]);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // -------------------- Render

  return (
    <motion.div variants={variants}>
      <RhLink href={uri} className={cx(["list-cover-stories-item"])} onClick={handleClick}>
        <p className={cx(["title", "title-lc-s"])}>#{gameNumber} - {title}</p>
        <div className={cx("pill-wrapper")}>
          {hasPlayed && (
            <p className={cx("pill", "pill--played")}>
              {didWin
                ? (guessCount === 1
                    ? Copy_ItemLabels.solvedSingular
                    : Copy_ItemLabels.solvedPlural.replace('{{COUNT}}', String(guessCount))
                  )
                : Copy_ItemLabels.lostLabel
              }
            </p>
          )}
          <p className={cx("pill")}>{date}</p>
        </div>
      </RhLink>
    </motion.div>
  );

}
